"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SkeletonItem: function() {
        return _index.SkeletonItem;
    },
    renderSkeletonItem_unstable: function() {
        return _index.renderSkeletonItem_unstable;
    },
    skeletonItemClassNames: function() {
        return _index.skeletonItemClassNames;
    },
    useSkeletonItemStyles_unstable: function() {
        return _index.useSkeletonItemStyles_unstable;
    },
    useSkeletonItem_unstable: function() {
        return _index.useSkeletonItem_unstable;
    }
});
const _index = require("./components/SkeletonItem/index");
